import { PartStatusLabel } from '@/components/PartStatusLabel'
import { ProductStock } from '@/components/ProductStock/ProductStock'
import { ProductPartStatusEnum } from '@/schemas/productPartStatusEnumSchema'

import type * as React from 'react'
import type { Product } from '@/gen/ecom'
import type { SilWebProductSchema } from '@/schemas/silWebProductSchema'

interface Props {
  // TODO: migrate to our types
  product?: Product | SilWebProductSchema
}

export const ProductPartStatusAndStock: React.FC<Props> = ({ product }) => {
  const showPartStatusLabel =
    product?.productPartStatus === ProductPartStatusEnum.P || product?.productPartStatus === ProductPartStatusEnum.O

  return showPartStatusLabel ? (
    <PartStatusLabel partStatus={product?.productPartStatus} />
  ) : (
    <ProductStock productStock={product?.productStock} />
  )
}
